import { assertNotEmpty, notEmpty } from '@festina-life/core'

import { useHook } from '../../../lenteHooks'
import { useAvailableComponents } from '../../useAvailableComponents'

export const useInternalIdResolver = () => {
  const tenantId = useHook('routing.tenant.useTenantParam')({
    isOptional: true,
  })
  const { isUsingLegalEntity } = useAvailableComponents()

  const { mutateAsync: handleSearchInternalId } = useHook(
    'lazyFetchers.crm.useLazyFetchInternalId',
  )()
  const isExternalId = (id: string) => {
    try {
      assertNotEmpty(tenantId)
      return handleSearchInternalId({ externalId: id, tenantId })
    } catch {
      return null
    }
  }

  const { mutateAsync: handleSearchExternalId } = useHook(
    'lazyFetchers.crm.useLazyFetchExternalId',
  )()
  const isInternalId = async (id: string) => {
    try {
      assertNotEmpty(tenantId)
      await handleSearchExternalId({ internalId: id, tenantId })
      return id
    } catch {
      return null
    }
  }

  return async (internalOrExternalId: string) => {
    if (!isUsingLegalEntity) {
      return [internalOrExternalId]
    }
    const [internalIdResult, externalIdResult] = await Promise.allSettled([
      isInternalId(internalOrExternalId),
      isExternalId(internalOrExternalId),
    ])

    const existingInternalId =
      internalIdResult.status === 'fulfilled' && !!internalIdResult.value
        ? internalIdResult.value
        : undefined
    const internalIdFromExternalSearch =
      externalIdResult.status === 'fulfilled' && !!externalIdResult.value
        ? externalIdResult.value
        : undefined

    return [
      ...new Set([existingInternalId, internalIdFromExternalSearch]),
    ].filter(notEmpty)
  }
}
